export default __webpack_public_path__ + "static/media/e-nstitute-mobile-two.9f0cfae1.png";